import * as React from "react";

/**
 * Retorna o valor de comparação entre duas strings utilizado pela função <Array>.sort.
 * @param {string} a - Texto a ser comparado
 * @param {string} b - Texto a ser comparado
 * @param {boolean} caseSensitive - Define se a comparação irá considerar a diferença
 *                                  entre caracteres maiúsculos e minúsculos
 * @returns {number}
 */
export function normalize(text: string): string {
  if (!text) return "";

  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function trim(text: string): string {
  if (!text) return text;
  return text
    .trim()
    .replace(/(&nbsp;)+/g, " ")
    .replace(/\s+/g, " ")
    .replace(/ {2,}/g, " ");
}

export function sortString(
  a: string,
  b: string,
  caseSensitive: boolean = false
): number {
  if (!caseSensitive) {
    a = a.toUpperCase();
    b = b.toUpperCase();
  }

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

export function insertTagsAtText(message: string) {
  const components: any[] = [];
  let start = true,
    index = 0;

  // Adiciona tag b de negrito
  while (message.indexOf("*", index) !== -1) {
    const indexOfTag = message.indexOf("*", index);
    const subText = message.substring(index, indexOfTag);

    components.push(start ? subText : <b>{subText}</b>);
    index = indexOfTag + 1;
    start = !start;
  }

  components.push(message.substring(index));
  return components;
}



// WEBPACK FOOTER //
// ./src/utils/StringUtils.tsx